import Vue from "vue";
import store from "../store";
import axios from "axios";
import router from "@/router";
import JQuery from "jquery";
import Swal from "sweetalert2";

const $ = JQuery;

const frontendAxios = axios.create();
const redirectUri = process.env.VUE_APP_FUBON_DOMAIN_URL;

// 計算當前 ajax 數
let loadingCount = 0;

frontendAxios.interceptors.request.use(
  config => {
    // 打 ajax 前開啟 loading
    if (window.showRequestLoadingSwal === true) {
      if (loadingCount === 0) {
        // Swal.fire({
        //   // title: '資料處理中，請稍候',
        //   // imageUrl: require('@/assets/images/loading/sheep.gif'),
        //   // imageHeight: 70,
        //   allowOutsideClick: false,
        //   onOpen: function onOpen() {
        //     Swal.showLoading();
        //   }
        // });
        Swal.fire({
          title: "資料載入中, 請稍候",
          heightAuto: false,
          allowOutsideClick: false,
          onOpen: function onOpen() {
            Swal.showLoading();
          }
        });
      }
      loadingCount++;
    }
    // 自動登出計時器重置
    // if(process.env.VUE_APP_AUTO_LOGOUT_SECONDS !== ''){
    //   store.commit('resetLogoutCountdown');
    // }

    // axios 請求攔截器，加上 header
    config.timeout = 30000;
    config.headers.Accept = "application/json";
    config.headers["Content-Type"] = "application/json";

    const token = window.localStorage.getItem("token");
    if (token !== null) {
      config.headers.Authorization = token; // eslint-disable-line
    }

    return config;
  },
  err => Promise.reject(err)
);

/* 處理 Laravel Validate Fail */
frontendAxios.interceptors.response.use(
  response => {
    if (window.showRequestLoadingSwal === true) {
      // ajax 成功，關閉 loading
      loadingCount--;
      if (loadingCount === 0) {
        Swal.close();
      }
    }

    return response;
  },
  error => {
    // ajax 失敗，關閉 loading
    if (window.showRequestLoadingSwal === true) {
      loadingCount--;
      if (loadingCount === 0) {
        Swal.close();
      }
    }

    // Do something with response error
    if (error.response.status === 422) {
      const errorMsg = error.response.data.errors;

      let errorText = "";

      $.each(errorMsg, (columnName, errorContents) => {
        $.each(errorContents, (key, thisErrorMsg) => {
          errorText += `${thisErrorMsg}<br>`;
        });
      });

      Swal.fire({
        title: "驗證失敗",
        html: errorText,
        icon: "error",
        heightAuto: false,
        allowOutsideClick: false
      });
    } else if (error.response.status === 500) {
      // router.push({ name: '500', params: { message: error.response.data.message } });
      if (!error.response.data.message.includes('申請資料審核')) {
        Swal.fire({
          title: "操作失敗",
          html: error.response.data.message,
          icon: "error",
          heightAuto: false,
          allowOutsideClick: false
        });
      }
    } else if (error.response.status === 401) {
      window.localStorage.removeItem("token");

      window.location.replace(`${redirectUri}login`);

    } else if (error.response.status === 403) {
      // 非法請求，強制登出
      window.localStorage.removeItem("token");

      Swal.fire({
        title: error.response.data.message,
        icon: "info",
        heightAuto: false,
        allowOutsideClick: false
      });

      router.push({ name: "login" });

      return Promise.reject(error);
    } else if (error.response.status >= 300) {
      Swal.fire({
        title: "操作失敗",
        html: error.response.data.message,
        icon: "error",
        heightAuto: false,
        allowOutsideClick: false
      });
    }

    return Promise.reject(error.response);
  }
);

export default frontendAxios;
